<template>
  <section class="content">
    <div class="container-fluid">
      <loader v-if="loading" :type="'table'"/>
      <div v-else>
        <div v-show="show_categories_notice" class="row">
          <div class="col-12">
            <div class="alert alert-info">
              <h5><i class="icon fas fa-info"></i> {{translate('messages.atention')}}</h5>
              {{translate('messages.no_categories_message')}}
              <router-link to="/markers/categories" type="button" class="btn btn-secondary m-2">{{translate('messages.add')}} {{translate('messages.categories')}}</router-link>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <h1>{{translate('messages.my_markers')}}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">{{translate('messages.markers_list')}}</h3>

                <div class="card-tools">
                  <button type="button" class="btn btn-sm btn-primary" @click="newModal">
                      <i class="fa fa-plus-square"></i>
                      {{translate('messages.add_new', {})}}
                  </button>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body table-responsive p-0">
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>{{translate('messages.name')}}</th>
                      <th>{{translate('messages.description')}}</th>
                      <th>{{translate('messages.category')}}</th>
                      <th>url</th>
                      <th>{{translate('messages.actions')}}</th>
                    </tr>
                  </thead>
                  <tbody>
                     <tr v-for="marker in markers.data" :key="'marker-'+marker.id">

                      <td>{{marker.name}}</td>
                      <td v-if="marker.description">{{marker.description}}</td>
                      <td v-else></td>
                      <td v-if="marker.marker_category">{{marker.marker_category.name}}</td>
                      <td v-else><i>{{translate('messages.no_category')}}</i></td>
                      <td>{{marker.url}}</td>
                      <td>
                        
                        <a @click="editModal(marker)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.update')" data-toggle="tooltip">
                            <i class="fa fa-edit blue"></i>
                        </a>
                        
                        <a @click="deleteMarker(marker.id)" class="btn btn-link mb-1" v-tooltip:bottom="translate('messages.delete')" data-toggle="tooltip">
                            <i class="fa fa-trash red"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-if="!markers.data.length" class="text-center"><small>-{{translate('messages.no_data')}}-</small></div>
              </div>
              <!-- /.card-body -->
              <div class="card-footer">
                  <pagination :data="markers" @pagination-change-page="getResults"></pagination>
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
      </div>
        <!-- Modal -->
        <div class="modal fade" id="addNew" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-show="!editmode">{{translate('messages.create_marker')}}</h5>
                    <h5 class="modal-title" v-show="editmode">{{translate('messages.update_marker')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form @submit.prevent="editmode ? updateMarker() : createMarker()">
                    <div class="modal-body">
                        <div class="form-group">
                            <label>{{translate('messages.name')}}</label>
                            <input v-model="form.name" type="text" name="name"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                            <has-error :form="form" field="name"></has-error>
                        </div>
                        <div class="form-group">
                            <label>{{translate('messages.description')}}</label>
                            <input v-model="form.description" type="text" name="description"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('description') }">
                            <has-error :form="form" field="description"></has-error>
                        </div>
                        <div class="form-group">
                            <label>url</label>
                            <input v-model="form.url" type="text" name="url"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('url') }">
                            <has-error :form="form" field="url"></has-error>
                        </div>
                        <div class="form-group">

                            <label>{{translate('messages.category')}}</label>
                            <select class="form-control" v-model="form.marker_category_id" :class="{ 'is-invalid': form.errors.has('marker_category_id') }">
                              <option 
                                  v-for="(cat,index) in marker_categories" :key="'cat-'+index"
                                  :value="index"
                                  :selected="index == form.marker_category_id">{{ cat }}</option>
                            </select>
                            <has-error :form="form" field="marker_category_id"></has-error>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">{{translate('messages.close')}}</button>
                        <button v-show="editmode" type="submit" class="btn btn-success">{{translate('messages.update')}}</button>
                        <button v-show="!editmode" type="submit" class="btn btn-primary">{{translate('messages.create')}}</button>
                    </div>
                  </form>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    import VueTagsInput from '@johmun/vue-tags-input';

    export default {
      components: {
          VueTagsInput,
        },
        data () {
            return {
                editmode: false,
                markers : {},
                form: new Form({
                    id : '',
                    category : '',
                    name: '',
                    description: '',
                    url: '',
                    marker_category_id: '',
                }),
                marker_categories: [],
                show_categories_notice: false,
                loading : true,
                page : 1
            }
        },
        methods: {

          getResults(page = 1) {

              this.$Progress.start();
              this.page = page;
              axios.get('/api/marker?page=' + page).then(({ data }) => {
                this.markers = data.data;
                this.loading = false;
                this.$root.$emit('updateMarkersNavbar');
                this.$Progress.finish();
                if(!this.markers.data.length && this.page > 1){
                  this.getResults(this.page - 1);
                }
              });

          },
          loadMarkerCategories(){
              axios.get("/api/markerCategory/list").then(({ data }) => {
                this.marker_categories = data.data;
                if(Object.keys(this.marker_categories).length == 0) this.show_categories_notice = true;
              });
          },
          editModal(product){
              this.editmode = true;
              this.form.reset();
              $('#addNew').modal('show');
              this.form.fill(product);
          },
          newModal(){
              this.editmode = false;
              this.form.reset();
              $('#addNew').modal('show');
          },
          createMarker(){
              this.$Progress.start();
              this.form.update({_method:'post'});
              this.form.post('/api/marker')
              .then((response)=>{
                $('#addNew').modal('hide');

                Toast.fire({
                      icon: 'success',
                      title: response.data.message
                  });
                this.$Progress.finish();
                this.getResults();
              })
              .catch((error)=>{
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              })
          },
          updateMarker(){
              this.$Progress.start();
              this.form.update({_method:'put'});
              this.form.post('/api/marker/'+this.form.id)
              .then((response) => {
                  // success
                  $('#addNew').modal('hide');
                  Toast.fire({
                    icon: 'success',
                    title: response.data.message
                  });
                  this.$Progress.finish();
                      //  Fire.$emit('AfterCreate');
                  this.getResults(this.page);
              })
              .catch((error) => {
                let error_obj = JSON.parse(error.request.response);
                let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                Toast.fire({
                    icon: 'error',
                    title: error_title
                });
                this.$Progress.fail();
              });

          },
          deleteMarker(id){
            Swal.fire({
              title: window.translate('messages.are_you_sure'),
              text: window.translate('messages.no_revert'),
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              cancelButtonText: window.translate('messages.cancel'),
              confirmButtonText: window.translate('messages.delete_confirm')
              })
              .then((result) => {
                // Send request to the server
                if (result.value) {
                  this.$Progress.start();
                  this.form.delete('/api/marker/'+id).then((response)=>{
                    this.$Progress.finish();
                    Toast.fire({
                      icon: 'success',
                      title: response.data.message
                    });
                    // Fire.$emit('AfterCreate');
                    this.getResults(this.page);
                  }).catch((error)=> {
                    let error_obj = JSON.parse(error.request.response);
                    let error_title = typeof(error_obj.message) !== null && error.request.status < 500 ? error_obj.message : window.translate('messages.error_ocurred');
                    if(error_title=='The given data was invalid.') error_title = window.translate('messages.invalid_data');
                    Toast.fire({
                      icon: 'error',
                      title: error_title
                    });
                    this.$Progress.fail();
                  });
                }
              })
          },

        },
        mounted() {
  
          },
        created() {
          this.getResults();
          this.loadMarkerCategories();
        }
    }
</script>
